import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import { NAV, CONTACT } from "../data/site";
import { EASE } from "./motion";

export const MobileMenu = ({ onClose }) => (
  <motion.div
    id="mobile-menu"
    role="dialog"
    aria-modal="true"
    aria-label="Menu"
    className="fixed inset-0 z-[60] flex flex-col bg-ink px-5 pb-10 pt-5 text-paper sm:px-10"
    initial={{ clipPath: "inset(0% 0% 100% 0%)" }}
    animate={{ clipPath: "inset(0% 0% 0% 0%)" }}
    exit={{ clipPath: "inset(0% 0% 100% 0%)" }}
    transition={{ duration: 0.7, ease: EASE }}
    data-testid="mobile-menu"
  >
    <div className="flex items-center justify-between">
      <Link to="/" onClick={onClose} aria-label="Home"><img src="/img/mark-light.png" alt="" className="h-9 w-auto" /></Link>
      <button type="button" onClick={onClose} className="flex items-center gap-2 py-2 text-xs uppercase tracking-[0.2em]" data-testid="mobile-menu-close">
        Chiudi <X size={18} strokeWidth={1.25} />
      </button>
    </div>
    <nav className="mt-16 flex flex-col gap-2" aria-label="Navigazione mobile">
      {[{ to: "/", label: "Home" }, ...NAV].map((n, i) => (
        <div key={n.to} className="overflow-hidden">
          <motion.div initial={{ y: "100%" }} animate={{ y: 0 }} transition={{ duration: 0.8, ease: EASE, delay: 0.25 + i * 0.07 }}>
            <Link to={n.to} onClick={onClose} className="flex items-baseline gap-4 py-1 font-serif text-5xl" data-testid={`mobile-nav-${n.label.toLowerCase()}`}>
              <span className="font-sans text-xs text-mint/70">0{i + 1}</span>{n.label}
            </Link>
          </motion.div>
        </div>
      ))}
    </nav>
    <div className="mt-auto space-y-2 text-sm text-paper/75">
      <a href={`mailto:${CONTACT.email}`} className="block">{CONTACT.email}</a>
      <p>Strategia · Produzione · Gestione</p>
    </div>
  </motion.div>
);
